import React from "react"
import ReactMarkdown from "react-markdown"

const Basic = ({content}) => (
  <div className='content'>
    <ReactMarkdown source={content} />
  </div>
)

export default Basic